export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0038s_0000_Black-&-White-7.947d9c37.png";